module.exports = __webpack_public_path__ + "static/media/YF58_1.6572898d.jpg";